import React from "react";
import { motion } from "framer-motion";
import "./Intro.css";
import profileImage from "../../assets/king.PNG";
import cv from "../../assets/DamianStanley-CV.pdf";
import { Link } from "react-router-dom";

// Animation variants
const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2,
      delayChildren: 0.3,
    },
  },
};

const itemVariants = {
  hidden: { y: 20, opacity: 0 },
  visible: {
    y: 0,
    opacity: 1,
    transition: { type: "spring", damping: 15 },
  },
};

const imageVariants = {
  hidden: { scale: 0.8, opacity: 0 },
  visible: {
    scale: 1,
    opacity: 1,
    transition: { type: "spring", stiffness: 100 },
  },
};

const Intro = () => {
  return (
    <motion.div
      className="intro-container"
      initial="hidden"
      animate="visible"
      variants={containerVariants}
    >
      <div className="intro-content">
        {/* Left Column - Animated Text */}
        <motion.div className="intro-text" variants={containerVariants}>
          <motion.span className="intro-handle" variants={itemVariants}>
            <Link to="https://x.com/_king_Damian?s=09" target="_blank">
              @_King_Damian
            </Link>
          </motion.span>

          <motion.h1 variants={itemVariants}>
            <span className="intro-greeting">Hello,</span>
            <br />
            I'm <span className="highlight">King Damian</span>
          </motion.h1>

          <motion.p className="intro-bio" variants={itemVariants}>
            CEO @{" "}
            <Link to="https://quortek.vercel.app" target="_blank">
              Quortek
            </Link>{" "}
            Company | Computer Scientist | Full Stack Developer | Mobile App Dev
            | Tech Enthusiast | AI Advocate | Tech Coach | Web3 Dev |
          </motion.p>

          <motion.div className="intro-stats" variants={itemVariants}>
            <div className="stat">
              <span className="stat-number">20+</span>
              <span className="stat-label">Projects</span>
            </div>
            <div className="stat">
              <span className="stat-number">4+</span>
              <span className="stat-label">Years</span>
            </div>
          </motion.div>

          <motion.div className="intro-actions" variants={itemVariants}>
            <motion.a
              href={cv}
              download
              className="action-button primary"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              Download CV
            </motion.a>
            <motion.a
              href="/contact-me"
              className="action-button secondary"
              whileHover={{
                backgroundColor: "rgba(29, 155, 240, 0.1)",
                borderColor: "#1d9bf0",
              }}
            >
              Contact →
            </motion.a>
          </motion.div>
        </motion.div>

        {/* Right Column - Animated Profile Image */}
        <motion.div className="intro-profile" variants={imageVariants}>
          <div className="profile-image-container">
            <motion.img
              src={profileImage}
              alt="King Damian"
              className="profile-image"
              whileHover={{ scale: 1.03 }}
              transition={{ type: "spring", stiffness: 300 }}
            />
            <motion.div
              className="profile-verified"
              animate={{
                scale: [1, 1.1, 1],
                rotate: [0, 10, -10, 0],
              }}
              transition={{
                repeat: Infinity,
                repeatType: "reverse",
                duration: 2,
              }}
            >
              <svg viewBox="0 0 24 24" aria-label="Verified account">
                <g>
                  <path d="M22.25 12c0-1.43-.88-2.67-2.19-3.34.46-1.39.2-2.9-.81-3.91s-2.52-1.27-3.91-.81c-.66-1.31-1.91-2.19-3.34-2.19s-2.67.88-3.33 2.19c-1.4-.46-2.91-.2-3.92.81s-1.26 2.52-.8 3.91c-1.31.67-2.2 1.91-2.2 3.34s.89 2.67 2.2 3.34c-.46 1.39-.21 2.9.8 3.91s2.52 1.26 3.91.81c.67 1.31 1.91 2.19 3.34 2.19s2.68-.88 3.34-2.19c1.39.45 2.9.2 3.91-.81s1.27-2.52.81-3.91c1.31-.67 2.19-1.91 2.19-3.34zm-11.71 4.2L6.8 12.46l1.41-1.42 2.26 2.26 4.8-5.23 1.47 1.36-6.2 6.77z"></path>
                </g>
              </svg>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </motion.div>
  );
};

export default Intro;
